import { createContext, useContext } from "react";
import type { Payment } from "../types/payment.types";

export interface PaymentOverviewContextType {
  payment: Payment | null;
  refetch: () => Promise<void>;
}

const PaymentOverviewContext =
  createContext<PaymentOverviewContextType | null>(null);

export const usePaymentOverview = () => {
  const context = useContext(PaymentOverviewContext);
  if (!context) {
    throw new Error("usePaymentOverview must be used within provider");
  }
  return context;
};

export default PaymentOverviewContext;
